import React, { useCallback } from 'react'
import PropTypes from 'prop-types'

import Button from '../../Button/Button'

import './RemoveItemButton.css'
import { useDeleteItemFromCart } from '../../CartMutation/CartMutation'
import { useHandleDelete } from '../use-modifier-form-helpers'
import { useCart } from '../../CartProvider/CartProvider'
import { useNestedModifiers } from '../NestedModifiersProvider/NestedModifiersProvider'
import { useFormik } from '../../FormikProvider/FormikProvider'
import { useAvailability } from '../../../utils/availability'
import { MenuItemDetailsShape } from '../NestedModifiersProvider/Models/MenuItemDetails'

export const RemoveItemButton = ({
  handleDeleteParams,
  updateError,
  itemDetails
}) => {
  const { cartGuid } = useCart()
  const { modalLoading, setModalLoading } = useNestedModifiers()
  const { values, isSubmitting } = useFormik()
  const [deleteItemFromCart, { error: deleteError }] = useDeleteItemFromCart()
  const { loading: availabilityLoading } = useAvailability()

  const handleDelete = useHandleDelete({
    cartGuid,
    itemGuid: itemDetails.guid,
    itemDetails,
    deleteItemFromCart,
    ...handleDeleteParams
  })

  if (deleteError) {
    updateError(deleteError)
  }

  const handleClick = useCallback(async () => {
    setModalLoading(true)
    try {
      await handleDelete(values)
    } catch (error) {
      updateError(error)
    } finally {
      setModalLoading(false)
    }
  }, [setModalLoading, handleDelete, updateError, values])

  const isDisabled = modalLoading || isSubmitting || availabilityLoading

  return (
    <div styleName='delete'>
      <Button data-testid='modifier-remove-item-button' onClick={handleClick} disabled={isDisabled}>
        Remove Item
      </Button>
    </div>
  )
}

const handleDeleteParamsShape = PropTypes.shape({
  selectionGuid: PropTypes.string.isRequired,
  getComputedPrice: PropTypes.func.isRequired,
  basePrice: PropTypes.number.isRequired
})

RemoveItemButton.propTypes = {
  handleDeleteParams: handleDeleteParamsShape.isRequired,
  updateError: PropTypes.func.isRequired,
  itemDetails: MenuItemDetailsShape.isRequired
}
